import { StripePrice } from "@switcherstudio/switcher-api-client";
import styles from "./PlanDetails.module.scss";
import { useTranslation } from "react-i18next";
import { displayAmount } from "helpers/stripe";
import { useMemo } from "react";
import { TFunction } from "i18next";
export interface PlanDetailsProps {
    item: StripePrice;
    percentSavings?: { name: string; percent: number }[];
    disabled?: boolean;
}

export const PlanDetails = ({
    item,
    percentSavings,
    disabled
}: PlanDetailsProps) => {
    const { t } = useTranslation();
    /** if item is 7-day pass and is disabled, replace cost with explanatory copy. */
    const sevenDayCostUnavailable =
        item?.Name === "Switcher Studio 7-Day Pass" && disabled;
    const cost = item?.Amount;
    const costUnavailable = t("subscription:unavailable");
    const savings = percentSavings?.filter((ps) =>
        item?.Name?.includes(ps?.name)
    )?.[0]?.percent;

    const getIntervalDisplay = (item: StripePrice, t: TFunction) => {
        const intervalMap = {
            nonRecurring: ` ${t("subscription:one-time-charge")}`,
            monthlySingle: `/${t("gated-content-page:month")}`,
            monthlyMultiple: `/${t("gated-content-page:months", {
                recurringIntervalCount: item?.RecurringIntervalCount
            })}`,
            yearly: `/${t("gated-content-page:year")}`
        };

        if (!item?.IsRecurring) return intervalMap.nonRecurring;

        if (item?.RecurringInterval === "month") {
            return item?.RecurringIntervalCount > 1
                ? intervalMap.monthlyMultiple
                : intervalMap.monthlySingle;
        }
        return intervalMap.yearly;
    };

    const intervalDisplay = useMemo(
        () => getIntervalDisplay(item, t),
        [item, t]
    );

    const savingsDisplay = useMemo(
        () => (savings ? ` (${Math.round(savings)}% savings)` : ""),
        [savings]
    );

    return (
        <div>
            <div className={`${disabled ? styles["disabled"] : ""}`}>
                <h6>{item?.DisplayName ?? item?.Name}</h6>
                <span>
                    {
                        <div>
                            {!sevenDayCostUnavailable
                                ? `${displayAmount(cost, {
                                      signed: true,
                                      compact: item?.IsRecurring,
                                      roundUp: false
                                  })}${intervalDisplay} ${savingsDisplay}`
                                : costUnavailable}
                        </div>
                    }
                </span>
            </div>
        </div>
    );
};
